import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface LoadFilters {
  search: string;
  startPickupDate: Date | null;
  endPickupDate: Date | null;
  startDeliveryDate: Date | null;
  endDeliveryDate: Date | null;
  status: string[];
  equipmentType: string[];
  customerId: string;
  carrierId: string;
  isBilled: boolean | null;
  isFollowUp: boolean;
}

interface LoadFilterState {
  filters: LoadFilters;
  activeTab: string;
  currentPage: number;
  limit: number;
}

const initialState: LoadFilterState = {
  filters: {
    search: '',
    startPickupDate: null,
    endPickupDate: null,
    startDeliveryDate: null,
    endDeliveryDate: null,
    status: [],
    equipmentType: [],
    customerId: '',
    carrierId: '',
    isBilled: null,
    isFollowUp: false,
  },
  activeTab: 'allLoad',
  currentPage: 1,
  limit: 10,
};

const loadFilterSlice = createSlice({
  name: 'loadFilter',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<LoadFilters>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
    setActiveTab: (state, action: PayloadAction<string>) => {
      state.activeTab = action.payload;
      state.currentPage = 1; // Reset to first page when tab changes
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
      state.currentPage = 1; // Reset to first page when limit changes
    },
    updateFilter: (state, action: PayloadAction<{ key: keyof LoadFilters; value: any }>) => {
      const { key, value } = action.payload;
      (state.filters as any)[key] = value;
    },
    clearAllFilters: (state) => {
      state.filters = initialState.filters;
      state.activeTab = initialState.activeTab;
      state.currentPage = initialState.currentPage;
      state.limit = initialState.limit;
    },
  },
});

export const {
  setFilters,
  resetFilters,
  setActiveTab,
  setCurrentPage,
  setLimit,
  updateFilter,
  clearAllFilters,
} = loadFilterSlice.actions;

export default loadFilterSlice.reducer;
